import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { mediaUrl, apiCall } from "../util";
import {
  gokulam_logo_icon,
  specialities_section_art_2,
  specialities_section_art_mobile,
  supporting,
  why_us,
} from "../Image";
import axios from "axios";
const OurSpeciality = () => {
  const [data, setData] = useState([]);
  const [titleData, setTitleData] = useState(null);
  useEffect(() => {
    const fetchSpecialityData = async () => {
      try {
        const response = await axios.get(apiCall + "department/getall");
        setData(response.data.filter((item) => item.isView === 1).slice(0, 8));
        const result = await axios.post(apiCall + "departmenttitle/getall");
        if (result.data[0]) {
          setTitleData(result.data[0]);
        }
      } catch (error) {
        console.error("Error fetching speciality data:", error);
      }
    };
    fetchSpecialityData();
  }, []);
  return (
    <section className="overflow-hidden half-section -py-5 position-relative">
      {/* Background Animations */}
      <img
        src={gokulam_logo_icon}
        alt="gokulam logo"
        className="animated-logo-3 rotate"
      />
      <img
        src={gokulam_logo_icon}
        alt="gokulam logo"
        className="animated-logo-4 float"
      />

      <div className="container z-3 position-relative">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-xl-6 col-lg-6">
            <ScrollAnimation
              animateIn="animate__fadeInUp"
              duration={0.6}
              animateOnce={true}
              offset={10}
            >
              <div className="d-flex align-items-center gap-2">
                <img src={why_us} className="h-60px" alt="" />
                <div>
                  <span className="text-base-color fw-600 -mb-5px text-uppercase d-block">
                    Hospital
                  </span>
                  <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                    Our{" "}
                    <span className="text-gradient-sg-red-purple">
                      Specialities
                    </span>
                  </h5>
                </div>
              </div>
              <p className="mt-3">
                {titleData?.title
                  ? titleData.title
                  : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}
              </p>
              <div className="specialities_cards_section">
                {data.map((dept, index) => (
                  <ScrollAnimation
                    key={dept.id}
                    animateIn="animate__fadeInUp"
                    duration={0.6}
                    animateOnce={true}
                    delay={index * 100}
                    offset={10}
                  >
                    <Link
                      to={`/department/${dept.slug}`}
                      state={{ departmentId: dept.id }}
                      className="specialities_cards"
                    >
                      <img
                        src={supporting}
                        alt={dept.name}
                        className="md-h-30px h-40px"
                      />
                      <h5>{dept.name}</h5>
                    </Link>
                  </ScrollAnimation>
                ))}
              </div>
              <Link
                to={"/our-specialities"}
                className="btn btn-gradient-sg-header d-table d-lg-inline-block lg-mb-15px sg-border-styled fw-600 pe-25px ps-25px mt-40px"
              >
                View all
                <i className="bi bi-arrow-up-right"></i>
              </Link>
            </ScrollAnimation>
          </div>

          {/* Right Content */}
          <div className="col-xl-6 col-lg-6">
            <ScrollAnimation
              animateIn="animate__fadeInUp"
              duration={0.6}
              animateOnce={true}
              offset={10}
            >
              <div className="position-relative">
                <picture>
                  <source
                    media="(max-width: 767px)"
                    srcSet={specialities_section_art_mobile}
                  />
                  <source
                    media="(min-width: 991px)"
                    srcSet={specialities_section_art_2}
                  />
                  <img
                    src={specialities_section_art_2}
                    className="img-fluid"
                    alt=""
                  />
                </picture>
                <div className="book_appointment_section">
                  <h5 className="fs-24 fw-600 mb-2 text-dark">
                    Looking for a Home Care Service
                  </h5>
                  <p className="fs-16 lh-md">
                    Our executive will call you back.
                  </p>
                  <Link
                    to={"tel:+918129272986"}
                    className="btn-gradient-sg-header sg-border-styled gap-2 ps-4 pt-4 pb-4 pe-4 fs-16 d-inline-flex align-items-center"
                  >
                    <span className="lh-1 text-nowrap">Contact Now</span>
                    <i className="fab fa-whatsapp fs-20"></i>
                    {/* <span className="bg-white text-base-color px-4 py-2 sg-border-styled ms-1">
                      <i className="fa-solid fa-chevron-right"></i>
                    </span> */}
                  </Link>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurSpeciality;

//selfuseffect
// import React, { useEffect, useState } from "react";
// import ScrollAnimation from "react-animate-on-scroll";
// import "animate.css/animate.min.css";
// import { apiCall, mediaUrl } from "../util";
// import axios from "axios";

// const OurSpeciality = () => {
//   const [data, setData] = useState([]);
//   const [titleData, setTitleData] = useState(null);
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(apiCall + "department/getall");
//         setData(response.data.filter((item) => item.isView === 1).slice(0, 8)); // Limit to 8 departments
//         const titleResponse = await axios.post(
//           apiCall + "departmenttitle/getall"
//         );
//         if (titleResponse.data && titleResponse.data[0]) {
//           setTitleData(titleResponse.data[0]);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   return (
//     <section className="overflow-hidden half-section -py-5 position-relative">
//       {/* Background Animations */}
//       <img
//         src={gokulam_logo_icon}
//         alt="gokulam logo"
//         className="animated-logo-3 rotate"
//       />
//       <img
//         src={gokulam_logo_icon}
//         alt="gokulam logo"
//         className="animated-logo-4 float"
//       />

//       <div className="container z-3 position-relative">
//         <div className="row align-items-center">
//           {/* Left Content */}
//           <div className="col-xl-6 col-lg-6">
//             <ScrollAnimation
//               animateIn="animate__fadeInUp"
//               duration={0.6}
//               animateOnce={true}
//             >
//               <div className="d-flex align-items-center gap-2">
//                 <img
//                   src={why_us}
//                   className="h-60px"
//                   alt=""
//                 />
//                 <div>
//                   <span className="text-base-color fw-600 -mb-5px text-uppercase d-block">
//                     Hospital
//                   </span>
//                   <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
//                     Our{" "}
//                     <span className="text-gradient-sg-red-purple">
//                       Specialities
//                     </span>
//                   </h5>
//                 </div>
//               </div>
//               <p className="mt-3 text-justify" style={{ textAlign: "justify" }}>
//                 {titleData?.title
//                   ? titleData.title
//                   : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}
//               </p>
//               <div className="specialities_cards_section">
//                 {data.map((dept, index) => (
//                   <ScrollAnimation
//                     key={dept.id}
//                     animateIn="animate__fadeInUp"
//                     duration={0.6}
//                     animateOnce={true}
//                     delay={index * 100}
//                   >
//                     <a href="#" className="specialities_cards">
//                       <img
//                         src={`${mediaUrl}/${dept.image}`} // Construct the image URL dynamically
//                         alt={dept.name}
//                         className="md-h-30px h-40px w-40px"
//                       />
//                       <h5>{dept.name}</h5>
//                     </a>
//                   </ScrollAnimation>
//                 ))}
//               </div>
//               <a
//                 href="#"
//                 className="btn btn-gradient-sg-header d-table d-lg-inline-block lg-mb-15px sg-border-styled fw-600 pe-25px ps-25px mt-40px"
//               >
//                 View all
//                 <i className="bi bi-arrow-up-right"></i>
//               </a>
//             </ScrollAnimation>
//           </div>

//           {/* Right Content */}
//           <div className="col-xl-6 col-lg-6">
//             <ScrollAnimation
//               animateIn="animate__fadeInUp"
//               duration={0.6}
//               animateOnce={true}
//             >
//               <div className="position-relative">
//                 <picture>
//                   <source
//                     media="(max-width: 767px)"
//                     srcSet="../assets/gokulam_images/specialities-section-art_mobile.svg"
//                   />
//                   <source
//                     media="(min-width: 991px)"
//                     srcSet="../assets/gokulam_images/specialities-section-art_2.svg"
//                   />
//                   <img
//                     src="../assets/gokulam_images/specialities-section-art_2.svg"
//                     className="img-fluid"
//                     alt=""
//                   />
//                 </picture>
//                 <div className="book_appointment_section">
//                   <h5 className="fs-24 fw-600 mb-2 text-dark">
//                     Looking for a Second Opinion
//                   </h5>
//                   <p className="fs-16 lh-md">
//                     Lorem ipsum dolor sit amet consectetur adipisicing elit
//                     Nihil assumenda suscipit
//                   </p>
//                   <a
//                     href="#"
//                     className="btn-gradient-sg-header sg-border-styled ps-4 pt-4 pb-4 pe-2"
//                   >
//                     Book an Appointment
//                     <span className="bg-white text-base-color px-4 py-2 sg-border-styled ms-1">
//                       <i className="fa-solid fa-chevron-right"></i>
//                     </span>
//                   </a>
//                 </div>
//               </div>
//             </ScrollAnimation>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default OurSpeciality;

//animejs
// import React, { useEffect } from "react";
// import anime from "animejs"; // Import anime.js if you plan to use it for animation

// const OurSpeciality = () => {
//   // Initialize anime.js animations
//   useEffect(() => {
//     anime({
//       targets: "[data-anime]",
//       translateY: (el) =>
//         JSON.parse(el.getAttribute("data-anime")).translateY || [0, 0],
//       opacity: (el) =>
//         JSON.parse(el.getAttribute("data-anime")).opacity || [0, 1],
//       duration: (el) =>
//         JSON.parse(el.getAttribute("data-anime")).duration || 600,
//       delay: (el, i) =>
//         (JSON.parse(el.getAttribute("data-anime")).delay || 0) +
//         i * (JSON.parse(el.getAttribute("data-anime")).staggervalue || 300),
//       easing: (el) =>
//         JSON.parse(el.getAttribute("data-anime")).easing || "easeOutQuad",
//     });
//   }, []);

//   return (
//     <>
//       <section className="overflow-hidden half-section -py-5 position-relative">
//         <img
//           src={gokulam_logo_icon}
//           alt="gokulam logo"
//           className="animated-logo-3 rotate"
//         />
//         <img
//           src={gokulam_logo_icon}
//           alt="gokulam logo"
//           className="animated-logo-4 float"
//         />
//         <div className="container z-3 position-relative">
//           <div className="row">
//             <div
//               className="col-xl-6 col-lg-6 order-1 position-relative  -lg-mb-15px"
//               // data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'
//             >
//               <div className="d-flex align-items-center gap-2">
//                 <img
//                   src={why_us}
//                   className="h-60px"
//                   alt=""
//                 />
//                 <div>
//                   <span className="text-base-color fw-600 -mb-5px text-uppercase d-block">
//                     Hospital
//                   </span>
//                   <h5 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
//                     Our{" "}
//                     <span className="text-gradient-sg-red-purple">
//                       Specialities
//                     </span>
//                   </h5>
//                 </div>
//               </div>
//               <p className="mt-3">
//                 Lorem ipsum dolor sit amet consectetur adipisicing elit.
//                 Expedita provident quos harum incidunt adipisci blanditiis
//                 maiores.
//               </p>
//               <div
//                 className="specialities_cards_section"
//                 data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'
//               >
//                 {[
//                   "Cardiology",
//                   "Cardio-Thoracic Surgery",
//                   "Endocrinology",
//                   "Medical Gastroenterology",
//                   "Surgical Gastroenterology",
//                   "Neuromedicine",
//                   "Neurosurgery",
//                   "Nephrology",
//                 ].map((speciality, index) => (
//                   <a key={index} href="#" className="specialities_cards">
//                     <img
//                       src="../assets/gokulam_images/icons/supporting.png"
//                       alt=""
//                       className="md-h-30px h-40px"
//                     />
//                     <h5>{speciality}</h5>
//                   </a>
//                 ))}
//               </div>
//               <a
//                 href="#"
//                 className="btn btn-gradient-sg-header d-table d-lg-inline-block lg-mb-15px sg-border-styled fw-600 pe-25px ps-25px mt-40px"
//               >
//                 View all
//                 <i className="bi bi-arrow-up-right"></i>
//               </a>
//             </div>

//             <div
//               className="-offset-md-1 col-xl-6 col-lg-6 order-2 order-md-3 overflow-hidden"
//               data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'
//             >
//               <div className="position-relative">
//                 <picture>
//                   <source
//                     media="(max-width: 767px)"
//                     srcSet="../assets/gokulam_images/specialities-section-art_mobile.svg"
//                   />
//                   <source
//                     media="(min-width: 991px)"
//                     srcSet="../assets/gokulam_images/specialities-section-art_2.svg"
//                   />
//                   <img
//                     src="../assets/gokulam_images/specialities-section-art_2.svg"
//                     className="img-fluid"
//                     alt=""
//                   />
//                 </picture>
//                 <div className="book_appointment_section">
//                   <h5 className="fs-24 fw-600 mb-2 text-dark">
//                     Looking for a Second Opinion
//                   </h5>
//                   <p className="fs-16 lh-md">
//                     Lorem ipsum dolor sit amet consectetur adipisicing elit
//                     Nihil assumenda suscipit
//                   </p>
//                   <a
//                     href="#"
//                     className="btn-gradient-sg-header sg-border-styled ps-4 pt-4 pb-4 pe-2"
//                   >
//                     Book an Appointment
//                     <span className="bg-white text-base-color px-4 py-2 sg-border-styled ms-1">
//                       <i className="fa-solid fa-chevron-right"></i>
//                     </span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default OurSpeciality;
